hrd.charts.PieChart = hrd.charts.AbstractChart.extend({
	init: function(options, dynamicOptions, customChartOptions) {
		this.staticChartOptions = $.extend(true, this._specificChartOptions(), customChartOptions || {});
		this._super(options, dynamicOptions, {useXs: false});
	},
	doChart: function(dynamicOptions){
		this._super(dynamicOptions);
		// set pie label colors in black
		d3.selectAll(this.settings.id + ' .c3-chart-arc text').style('fill', 'black');
	},
	doChartOptions: function(){
		return this.staticChartOptions;
	},
	_adaptSpecificChart: function(staticOptions, dynamicOptions){
		staticOptions.pie = {
			expand: dynamicOptions.expand,
			label : {
				show: dynamicOptions.showLabels,
				threshold: dynamicOptions.labelThreshold,
			}
		};
		if(dynamicOptions.formatPattern){
			staticOptions.pie.label.format = function(v, r){
				return d3locale.format(this.pattern)(this.useRatio ? r : v);
			}.bind({pattern: dynamicOptions.formatPattern, useRatio: dynamicOptions.useRatio});
		}
	},
	_dataToColumns: function(staticOptions, dynamicOptions){
		var data = dynamicOptions.data;
		var columns = [];
		var colors = {};
		if(data && $.isArray(data.series) && data.series.length > 0){
			var isMultiSerie = dynamicOptions.serieType == 'multiSerie';
			if(data.series.length === 1 && !isMultiSerie){
				// single serie with multi data
				var total = 0;
				var sliceThreshold = dynamicOptions.sliceThreshold != undefined ? dynamicOptions.sliceThreshold : 0;
				$.each(data.series[0].items, function(i, item){
					total += item.y;
				});
				var threshold = total * sliceThreshold;
				var otherAccumulator = 0;

				$.each(data.series[0].items, function(i, item){
					var serie = data.series[0];
					if(item.y >= threshold){
						columns.push([item.x, item.y]);
						if(serie.serieColor){
							colors[item.x] = serie.serieColor;
						}
					} else {
						otherAccumulator += item.y;
					}
				});

				if(otherAccumulator > 0){
					columns.push([dynamicOptions.otherSlice || 'OTHER', otherAccumulator]);
				}
			} else {
				// multiserie with single data
				var total = 0;
				var sliceThreshold = dynamicOptions.sliceThreshold != undefined ? dynamicOptions.sliceThreshold : 0;
				$.each(data.series, function(i, serie){
					$.each(serie.items, function(i, item){
						total += item.y;
					})
				});
				var threshold = total * sliceThreshold;
				var otherAccumulator = 0;

				$.each(data.series, function(i, serie){
					if(serie.items[0].y >= threshold){
						var sid = serie.serieName || serie.items[0].x;
						columns.push([sid, serie.items[0].y]);
						if(serie.serieColor){
							colors[sid] = serie.serieColor;
						}
					} else {
						otherAccumulator += serie.items[0].y;
					}
				});
				if(otherAccumulator > 0){
					columns.push([dynamicOptions.otherSlice || 'OTHER', otherAccumulator]);
				}

			}
		}
		staticOptions.data.colors = colors;
		staticOptions.data.columns = columns;
	}
});